export default {
  FETCH_LIQUID_TEMPLATES_REQUEST: 'FETCH_LIQUID_TEMPLATES_REQUEST',
  FETCH_LIQUID_TEMPLATES_SUCCESS: 'FETCH_LIQUID_TEMPLATES_SUCCESS',
  FETCH_LIQUID_TEMPLATES_FAILURE: 'FETCH_LIQUID_TEMPLATES_FAILURE',
  UPDATE_LIQUID_TEMPLATE: 'UPDATE_LIQUID_TEMPLATE',
  SAVE_LIQUID_TEMPLATES_REQUEST: 'SAVE_LIQUID_TEMPLATES_REQUEST',
  SAVE_LIQUID_TEMPLATES_SUCCESS: 'SAVE_LIQUID_TEMPLATES_SUCCESS',
  SAVE_LIQUID_TEMPLATES_FAILURE: 'SAVE_LIQUID_TEMPLATES_FAILURE'
}
